import { createStore } from "vuex"
import createPersistedState from "vuex-persistedstate"
import SecureLS from "secure-ls"

import auth from "./modules/auth"

const ls = new SecureLS({ isCompression: false });

export default createStore({
	namespaced: true,
	modules: {
		auth,
	},
	plugins: [
		createPersistedState({
			key: "xsurflog",
			storage: {
				getItem: (key) => ls.get(key),
				setItem: (key, value) => ls.set(key, value),
				removeItem: (key) => ls.remove(key),
			},
		}),
	],
});